export const ShkoderTravelGuideLogo = () => {
  return (
    <svg
      width="100%"
      viewBox="0 0 900 700"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="900" height="700" fill="white" />

      {/* Arches */}
      <g>
        {/* Bridge */}
        <path
          d="M140 80C140 40 170 10 210 10H250C290 10 320 40 320 80V300H140V80Z"
          fill="#D8CFB1"
        />
        <path
          d="M150 240C180 190 280 190 310 240"
          stroke="#23311F"
          strokeWidth="10"
        />
        <path d="M175 240V300" stroke="#23311F" strokeWidth="10" />
        <path d="M235 240V300" stroke="#23311F" strokeWidth="10" />
        <path d="M295 240V300" stroke="#23311F" strokeWidth="10" />

        {/* Minaret */}
        <path
          d="M340 50C340 20 365 0 395 0H445C475 0 500 20 500 50V300H340V50Z"
          fill="#D9D2B0"
        />
        <rect x="410" y="80" width="20" height="170" fill="#F5F2E8" />
        <polygon points="420,20 395,80 445,80" fill="#23311F" />

        {/* Castle */}
        <path
          d="M520 40C520 15 545 0 570 0H640C665 0 690 15 690 40V300H520V40Z"
          fill="#B7B089"
        />
        <rect x="560" y="120" width="90" height="80" fill="#8D7B52" />
        <rect x="540" y="160" width="140" height="20" fill="#6D5D3B" />

        {/* Tree */}
        <path
          d="M710 70C710 30 740 0 780 0H820C860 0 890 30 890 70V300H710V70Z"
          fill="#C58F45"
        />
        <circle cx="800" cy="190" r="60" fill="#23311F" />
        <rect x="792" y="210" width="16" height="70" fill="#23311F" />
      </g>

      {/* Main Title */}
      <text
        x="450"
        y="430"
        textAnchor="middle"
        fontSize="95"
        fontFamily="Georgia, serif"
        fill="#23311F"
        letterSpacing="8"
      >
        SHKODER
      </text>

      {/* Subtitle */}
      <text
        x="450"
        y="510"
        textAnchor="middle"
        fontSize="42"
        fontFamily="Arial, sans-serif"
        fill="#C58F45"
        letterSpacing="10"
      >
        TRAVEL GUIDE
      </text>

      {/* Tagline */}
      <text
        x="450"
        y="570"
        textAnchor="middle"
        fontSize="24"
        fontFamily="Arial, sans-serif"
        fill="#111"
        letterSpacing="6"
      >
        EXPLORE. EXPERIENCE. REMEMBER.
      </text>

      {/* Decorative lines */}
      <line
        x1="150"
        y1="495"
        x2="260"
        y2="495"
        stroke="#C58F45"
        strokeWidth="3"
      />
      <line
        x1="640"
        y1="495"
        x2="750"
        y2="495"
        stroke="#C58F45"
        strokeWidth="3"
      />

      {/* Compass */}
      <g transform="translate(450 625)">
        <polygon
          points="0,-20 6,-6 20,0 6,6 0,20 -6,6 -20,0 -6,-6"
          fill="#C58F45"
        />
      </g>
    </svg>
  );
};

export default ShkoderTravelGuideLogo;
